import { useMemo } from 'react';
import { useAppSelector } from './redux';
import { buildSegmentDisplayNameMap } from '../utils/simulationTrackNetworkView';

export function useSegmentDisplayNameMap(): Map<string, string> {
  const elements = useAppSelector((state) => state.layout.elements);
  const elementOrder = useAppSelector((state) => state.layout.elementOrder);

  return useMemo(
    () => buildSegmentDisplayNameMap(Object.values(elements), elements, elementOrder),
    [elements, elementOrder]
  );
}

export function useLayoutDisplayNameContext() {
  const elements = useAppSelector((state) => state.layout.elements);
  const elementOrder = useAppSelector((state) => state.layout.elementOrder);
  const segmentDisplayNameMap = useSegmentDisplayNameMap();

  return useMemo(
    () => ({ elements, elementOrder, segmentDisplayNameMap }),
    [elements, elementOrder, segmentDisplayNameMap]
  );
}
